import { useQuery } from '@tanstack/react-query';

import adminAxios from '@/apis/admin-api/axios';

import { UserAccess } from '../types';

const getOrganizationUserProductAccesses = async (organizationId: string): Promise<UserAccess[]> => {
  const { data } = await adminAxios.post<UserAccess[]>(
    `/api/Subscription/GetOrganizationUserProductAccesses?organizationId=${organizationId}`
  );
  return data;
};

export const useGetOrganizationUsersAccesses = (organizationId: string) => {
  return useQuery<UserAccess[]>({
    queryKey: ['product-accesses', organizationId],
    queryFn: () => getOrganizationUserProductAccesses(organizationId),
    enabled: !!organizationId,
  });
};
